// OKAPI-1198
export const REQUEST_URL_LIMIT = 8192;
